import { useContext, useEffect, useState } from "react";
import PopUp from "../PopUp";
import api from "../api/api";
import { AppContext } from "../../App";

export default function EditProducts() {
	const {
		editProductsPopupVisible,
		setEditProductsPopupVisible,
		setConfirm,
		setLoading,
		categories,
		selectedEditCategory,
		loadProducts,
		loadMenu,
		shop,
	} = useContext(AppContext);
	const [product, setProduct] = useState(false);
	const [departments, setDepartments] = useState([]);
	const [active, setActive] = useState(1);

	useEffect(() => {
		loadInitialData();
	}, []);

	const loadInitialData = async () => {
		const isEdit = editProductsPopupVisible !== true;
		setLoading(true);
		try {
			const requests = [
				api.postProtected("/departments/list/", {
					per_pag: 300,
					orderby: "value,name",
				}),
			];
			if (isEdit)
				requests.unshift(
					api.postProtected("/products/get/" + editProductsPopupVisible + "/")
				);

			const responses = await Promise.all(requests);
			let productRes = null;
			let departmentsRes = null;

			if (isEdit) {
				productRes = responses[0];
				departmentsRes = responses[1];
			} else {
				departmentsRes = responses[0];
			}

			if (departmentsRes.success == 1) setDepartments(departmentsRes.rows || []);
			else
				setConfirm({
					title: "Errore",
					message: departmentsRes.error,
				});

			if (isEdit) {
				if (productRes.success == 1) {
					setProduct(productRes.data);
					setActive(Number(productRes.data?.active) === 1 ? 1 : 0);
				} else
					setConfirm({
						title: "Errore",
						message: productRes.error,
					});
			} else {
				setActive(1);
			}
		} catch {
			setConfirm({
				title: "Errore",
				message: "Errore nel caricamento dei dati prodotto",
			});
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		const data = Object.fromEntries(formData.entries());
		data.active = active;
		if (typeof data.price === "string")
			data.price = data.price.replace(/\s/g, "").replace(",", ".");
		setLoading(true);
		try {
			let res;
			if (product) {
				res = await api.postProtected("/products/edit/" + product.id + "/", data);
			} else {
				res = await api.postProtected("/products/add/", data);
			}
			if (res.success == 1) {
				await loadProducts();
				if (typeof loadMenu === "function") await loadMenu();
				setEditProductsPopupVisible(false);
			} else
				setConfirm({
					title: "Errore",
					message: res.error,
				});
		} catch {
			setConfirm({
				title: "Errore",
				message: "Errore nel salvataggio del prodotto",
			});
		} finally {
			setLoading(false);
		}
	};

	const defaultCategoryId =
		product && product.category_id ? product.category_id : selectedEditCategory || "";
	const defaultDepartmentId =
		product && product.department_id ? product.department_id : departments[0]?.id || "";
	const formKey = product ? "product-" + product.id : "product-new";
	const currencyCode = (shop?.currency || "EUR").toUpperCase();
	const currencySymbolMap = {
		EUR: "€",
		CHF: "CHF",
		DKK: "kr",
	};
	const currencySuffix = currencySymbolMap[currencyCode] || currencyCode;

	return (
		<PopUp
			options={{
				title: product ? "Modifica Prodotto" : "Nuovo Prodotto",
				onClose: () => setEditProductsPopupVisible(false),
			}}
		>
			<div className="inner-content">
				<div className="admin-edit-card">
					<form onSubmit={handleSubmit} className="admin-edit-form" key={formKey}>
						<div className="admin-edit-toggle-row">
							{product && <div className="admin-edit-meta-id">ID: {product.id}</div>}
							<div className="admin-edit-toggle-label">In Vendita</div>
							<button
								type="button"
								className={"table-switch" + (Number(active) === 1 ? " is-yes" : " is-no")}
								onClick={() => setActive((prev) => (Number(prev) === 1 ? 0 : 1))}
								aria-pressed={Number(active) === 1}
							>
								<div className="table-switch-track">
									<span className="table-switch-label yes">SI</span>
									<span className="table-switch-label no">NO</span>
									<span className="table-switch-knob"></span>
								</div>
							</button>
							<input type="hidden" name="active" value={active} />
						</div>
						<div className="admin-edit-row admin-edit-row-product-main">
							<div className="admin-edit-field">
								<label>Nome Prodotto</label>
								<input
									type="text"
									name="name"
									defaultValue={product ? product.name : ""}
									required
								/>
							</div>
							<div className="admin-edit-field">
								<label>Prezzo</label>
								<div className="admin-edit-input-with-suffix">
									<input
										type="text"
										inputMode="decimal"
										pattern="^[0-9]+([,.][0-9]{0,2})?$"
										name="price"
										defaultValue={product ? String(product.price).replace(".", ",") : ""}
										onInput={(e) => {
											const sanitized = e.target.value
												.replace(/[^0-9,.\s]/g, "")
												.replace(/\s+/g, "")
												.replace(".", ",");
											e.target.value = sanitized;
										}}
										required
									/>
									<span className="admin-edit-input-suffix" aria-hidden="true">
										{currencySuffix}
									</span>
								</div>
							</div>
						</div>
						<div className="admin-edit-row">
							<div className="admin-edit-field">
								<label>Categoria</label>
								<select name="category_id" defaultValue={defaultCategoryId} required>
									{categories.map((category, i) => (
										<option key={i} value={category.id}>
											{category.name}
										</option>
									))}
								</select>
							</div>
							<div className="admin-edit-field">
								<label>Reparto IVA</label>
								<select
									name="department_id"
									defaultValue={defaultDepartmentId}
									key={"department-" + defaultDepartmentId + "-" + departments.length}
								>
									<option value="">Seleziona reparto IVA</option>
									{departments.map((department) => (
										<option key={department.id} value={department.id}>
											{department.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className="admin-edit-submit-row">
							<button type="submit" className="admin-edit-submit">
								Salva Prodotto
							</button>
						</div>
					</form>
				</div>
			</div>
		</PopUp>
	);
}
